<template>
    <app-cmp-tabs default="content" v-if="this.element">
        <div class="flex" slot-scope="{ toggle, active }">
            <app-cmp-tabs-trigger name="content" :handle-click="toggle" :active="active">
                <i class="fal fa-file-alt"></i>Content
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="box" :handle-click="toggle" :active="active">
                <i class="fal fa-th-large"></i>Box Model
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="design" :handle-click="toggle" :active="active">
                <i class="fal fa-pencil-alt"></i>Design
            </app-cmp-tabs-trigger>
        </div>
        <div slot="items" slot-scope="{ active }">
            <app-cmp-tabs-content name="content" :active="active">
                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Use global element
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-global-element block="testimonials-section" :locale="locale" v-model="element.object.global.enabled" @onGetValues="setGlobalValues" />
                    </div>
                </div>

                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Properties
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Title
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-text
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            name="title"
                            placeholder=""
                            v-model="element.object.values.title"
                        />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Sub title
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-text
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            name="Sub title"
                            placeholder=""
                            v-model="element.object.values.sub_title"
                        />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Text colour
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-colour-field class="reset" placeholder="Text colour" :classes="{ input: { 'input--composer': true } }"  v-model="element.object.values.colour" />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Navigation background colour
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-colour-field class="reset" placeholder="Navigation background colour" :classes="{ input: { 'input--composer': true } }"  v-model="element.object.values.navigation_background" />
                    </div>
                </div>

                <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Navigation colour
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-colour-field class="reset" placeholder="Navigation colour" :classes="{ input: { 'input--composer': true } }"  v-model="element.object.values.navigation_colour" />
                    </div>
                </div>

                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Testimonials
                </div>
                <app-draggable :list="element.object.values.items" class="p-4" :options="{draggable:'.draggable', handle:'.draggable'}" v-if="element.object.values.items.length > 0">
                    <app-collapseable-box
                        v-for="(item, index) in element.object.values.items"
                        class="draggable mb-4"
                        :key="index"
                        :index="index"
                        @remove="remove"
                    >
                        <div slot="header" class="flex items-center justify-between">
                            <div>
                                <h4 v-html="`Testimonial ${(index + 1)} `" />
                            </div>
                            <div v-if="removeable" class="cursor-pointer z-20 p-1" @click="remove(index)">
                                <app-icon icon="times" class="text-red text-sm" />
                            </div>
                        </div>

                        <app-cmp-trix-field
                            label="Message"
                            :classes="{ wrapper: { 'reset': false } }"
                            v-model="element.object.values.items[index].message"
                        />

                        <app-field-text
                            label="Author"
                            v-model="element.object.values.items[index].author"
                        />

                        <app-field-file
                            label="Image"
                            v-model="element.object.values.items[index].image"
                            :types="{images: true, files: false}"
                        />

                        <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                            <div class="w-1/2">
                                <label class="text-xs text-grey-darker">
                                    Location
                                </label>
                            </div>
                            <div class="w-1/2 text-right">
                                <app-field-select class="reset" :classes="{ input: { 'input--composer': true } }" :items="fields.location.options" v-model="element.object.values.items[index].location" />
                            </div>
                        </div>

                        <!-- <app-field-text
                            label="Location"
                            v-model="element.object.values.items[index].location"
                        /> -->

                    </app-collapseable-box>
                </app-draggable>
                <p v-else class="p-4 text-sm">
                    There are currently no testimonials.
                </p>

                <div class="px-4 text-right w-full">
                    <app-button element="a" class="btn  btn--primary  btn--primary--sml" @click="add">
                        Add
                    </app-button>
                </div>
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="box" :active="active">
                <app-cmp-box-model
                    :element="element.object"
                />

                <app-cmp-border
                    :element="element.object"
                />
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="design" :active="active">
                <app-cmp-design
                    :element="element.object"
                />
            </app-cmp-tabs-content>
        </div>
    </app-cmp-tabs>
</template>

<script>
    /* API */
    import Api from '@/api/index.js';
    import Auth from '@/api/auth.js';

    import CmpTabs from '@/components/composer/Tabs/Tabs';
    import CmpTabsTrigger from '@/components/composer/Tabs/TabsTrigger';
    import CmpTabsContent from '@/components/composer/Tabs/TabsContent';
    import CmpBoxModel from '@/components/composer/Forms/Partials/BoxModel';
    import CmpBorder from '@/components/composer/Forms/Partials/Border';
    import CmpDesign from '@/components/composer/Forms/Partials/Design';

    import ColourField from '@/components/fields/inputs/Colour';
    import Button from '@/components/Button';
    import CollapseableBox from '@/components/CollapseableBox';
    import TextField from '@/components/fields/inputs/Text';
    import FileField from '@/components/fields/inputs/File';
    import SelectField from '@/components/fields/inputs/Select';
    import ComposerTrixField from '@/components/composer/Fields/Trix';

    import draggable from 'vuedraggable';

    import GlobalField from '@/components/composer/Fields/Global';
    import GlobalMixin from '@/components/composer/Mixins/Global';

    export default {
        components: {
            'app-draggable': draggable,
            'app-button': Button,
            'app-collapseable-box': CollapseableBox,
            'app-cmp-tabs': CmpTabs,
            'app-cmp-tabs-trigger': CmpTabsTrigger,
            'app-cmp-tabs-content': CmpTabsContent,
            'app-cmp-box-model': CmpBoxModel,
            'app-cmp-border': CmpBorder,
            'app-cmp-design': CmpDesign,
            'app-colour-field': ColourField,
            'app-field-text': TextField,
            'app-field-file': FileField,
            'app-field-select': SelectField,
            'app-cmp-trix-field': ComposerTrixField,
            'app-global-element': GlobalField
        },
        mixins: [ GlobalMixin ],
        props: {
            element: {
                type: Object,
                required: true
            },
            locale: {
                required: false
            },
            removeable: {
                type: Boolean,
                required: false,
                default: true
            }
        },
        data: () => ({
            fields: {
                message: {
                    name: 'Message',
                    attribute: 'message'
                },
                author: {
                    name: 'Author',
                    attribute: 'author'
                },
                image: {
                    name: 'Image',
                    attribute: 'image'
                },
                location: {
                    name: 'Location',
                    attribute: 'location',
                    options: [
                        {
                            value: 0,
                            label: 'All',
                        },
                    ]
                },
                title: {
                    name: 'Title',
                    attribute: 'title'
                },
                sub_title: {
                    name: 'Sub title',
                    attribute: 'sub_title'
                },
                colour: {
                    name: 'Text Colour',
                    attribute: 'colour'
                },
                navigation_background: {
                    name: 'Navigation background colour',
                    attribute: 'navigation_background'
                },
                navigation_colour: {
                    name: 'Navigation colour',
                    attribute: 'navigation_colour'
                },
            },
        }),

        created() {
            // Get all locations
            return Api.request('get', `locations/locations?filterForWebsite=true&&selectField=true`)
                .then(({ data }) => {
                    data.locations.forEach((location, index) => {
                        this.fields.location.options.push(location);
                    });
                });
        },

        methods: {
            add() {
                this.element.object.values.items.push({
                    'message': '',
                    'author': '',
                    'image': '',
                    'location': '',
                });
            },

            remove(index) {
                this.element.object.values.items.splice(index, 1);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/composer/Elements/TestimonialsSectionSettings.vue